import { degrees } from './degrees';

export const pathway = [
    {
        key: '5',
        name: 'What brings you back to the field of education?',
        options: [
            {
                name: 'Recertify my BC teaching certification',
                results: true,
                value: '5.1.1',
            },
            {
                name: 'Obtain BC Teacher Certification (i.e. I am an internationally qualified teacher)',
                value: '5.1.2',
                results: true,
            },
            {
                name: 'Professional Development',
                value: '5.1.3',
            },
            {
                name: 'I want to become a counsellor',
                results: true,
                value: '5.1.4',
            },
            {
                name: 'I want to conduct original academic research',
                value: '5.1.5',
            }
        ]
    },

    {
        key: '5.1.3',
        name: 'What credential are you interested in?',
        options: [
            {
                name: 'Post Baccalaureate Diploma',
                value: '5.1.3.3',
            },
            {
                name: 'Graduate Diploma',
                value: '5.1.3.2',
            },
            {
                name: 'Master’s Degree',
                value: '5.1.3.1',
            },
        ]
    },

    {
        key: '5.1.3.1',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies,
        ]
    },

    {
        key: '5.1.3.2',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        hideDrawer: true,
        // supportingText: 'A contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members.',
        maxSelection: 3,
        options: [
            ...degrees.graduateDiploma,
        ]
    },

    {
        key: '5.1.3.3',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.postBach
        ]
    },

    {
        key: '5.1.5',
        name: 'What credential are you interested in?',
        options: [
            {
                name: 'Master’s Degree',
                value: '5.1.5.1',
            },
            {
                name: 'Doctoral Degree',
                value: '5.1.5.2',
            },
        ]
    },

    {
        key: '5.1.5.1',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },

    {
        key: '5.1.5.2',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        // hideDrawer: true,
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },

];

export const results = [
    {
        id: '5.1.1',
        primary: {
            links: [
                {
                    title: 'Helping Ease Access for Returning Teachers (HEART)',
                    subtitle: 'For teachers who need to recertify in BC',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/heart/about.html'
                }
            ]
        }
    },
    {
        id: '5.1.2',
        primary: {
            links: [
                {
                    title: 'Professional Qualification Program (PQP)',
                    subtitle: 'For qualified teachers new to Canada',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pqp/about.html'
                },
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Graduate Diploma in Advanced Professional Studies in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                }
            ]
        }
    },
    {
        id: '5.1.3.1',
        primary: {
            links: [
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
                ...degrees.graduateStudies
            ]
        },
        secondary: {
            links: [
                // ...degrees.graduateStudies // THIS?
                {
                    title: 'Doctoral Degree Programs',
                }
            ]
        }
    },
    {
        id: '5.1.3.2',
        areasAsSubBullets: true,
        primary: {
            heading: 'Gradaute Diploma Programs via selected study area (up to 3)',
            subheading: 'Explore Graduate Diploma Programs in the areas of study you’re passionate about.',
            links: [
                {
                    title: 'Graduate Diploma in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                }
            ],
            degrees: [
                ...degrees.graduateDiploma
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Master of Education in Educational Practice, MEd EP',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/edpracticefp.html'
                }
            ]
        },
        footnote: {
            text: 'These programs are contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members. Learn about current offerings in your selected areas of study.'
        }
    },
    {
        id: '5.1.3.3',
        primary: {
            links: [
                ...degrees.postBach
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '5.1.4',
        primary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in Counselling and Human Development',
                    subtitle: 'Review the academic and experience prerequisites for the Master’s in Counselling Psychology programs',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html'
                },
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Counselling Psychology MA, Med',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/counspsych.html'
                }
            ]
        }
    },
    {
        id: '5.1.5.1',
        primary: {
            heading: 'Masters programs via selected study area (up to 3) > pull in filtered url link from program search.',
            subheading: 'Explore master’s degrees in the areas of study you’re passionate about.',
            links: [
                ...degrees.graduateStudies
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Doctoral Degree Programs',
                }
            ]
        }
    },
    {
        id: '5.1.5.2',
        areasAsSubBullets: true,
        primary: {
            links: [
                {
                    title: 'Graduate Diploma in Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                },

            ],
            degrees: [
                ...degrees.graduateDiploma
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Master of Education in Educational Practice, MEd EP',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/edpracticefp.html'
                }
            ]
        },
        footnote: {
            prerequisite: false,
            text: 'These programs are contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members. Learn about current offerings in your selected areas of study.'
        }
    }
]
